import React from 'react'
import ReactDOM from 'react-dom/client'
import { enableMapSet } from 'immer'
import App from './App'
import './styles/index.css'
import { initializeTheme } from './store/themeStore'

// Enable Immer MapSet plugin for Map/Set support in zustand stores
enableMapSet()

// Initialize theme system before rendering
initializeTheme()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)